import {AbstractVisionKey} from './AbstractVisionKey';

export class VisionKey extends AbstractVisionKey {
stepLevel: number | null;
}

